/**
 * Scroll from Judge.me preview badge review count to the reviews widget.
 */
(function () {
  const REVIEW_SELECTORS = [
    '.jdgm-rev-widg__title',
    '#judgeme_product_reviews',
    '.jdgm-rev-widg',
  ];

  /**
   * @returns {HTMLElement | null}
   */
  function getReviewTarget() {
    for (const selector of REVIEW_SELECTORS) {
      const target = document.querySelector(selector);
      if (target) return target;
    }

    return null;
  }

  /**
   * @param {HTMLElement} target
   */
  function scrollToReviewTarget(target) {
    const headerOffset = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-group-height'),
      10
    );
    const offset = Number.isFinite(headerOffset) && headerOffset > 0 ? headerOffset + 16 : 96;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest('.uniqueBorder');
    if (!trigger) return;

    const target = getReviewTarget();
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    scrollToReviewTarget(target);
  });
})();
